export default {"src":"/_next/static/media/TECH.21236f58.svg","height":18,"width":18};